module.exports = __webpack_public_path__ + "static/scale-model-of-newport-gangster-tour-in-cincinnati-ohio-a2050bd7e8441646cfc3b337267c4260.png";